import React from "react";
import { Link } from "react-router-dom";
import { useSEO } from "../components/site/Reveal";

export default function NotFound() {
  useSEO("Page Not Found", "The page you are looking for could not be found.");
  return (
    <div className="min-h-[70vh] grid place-items-center adire-bg grain-overlay px-6 text-center">
      <div>
        <p className="font-serif text-8xl text-gold mb-4">404</p>
        <h1 className="font-serif text-3xl text-cream mb-4">This path leads elsewhere</h1>
        <p className="text-cream/70 mb-8 max-w-md mx-auto">
          The page you seek is not here. Let us guide you back to the heart of Yorùbá culture.
        </p>
        <Link to="/" className="inline-flex bg-gold text-night font-semibold px-8 py-3.5 rounded-full hover:bg-gold-light transition-colors">
          Return Home
        </Link>
      </div>
    </div>
  );
}
